export default __webpack_public_path__ + "static/media/linkedin.d2396647.png";